import { IMonthlyBilling } from '@/modules/dashboard/types/wholesale';
import store from '@/store';

export const factoryRich = (): any => {
  const rich = store.state.auth.brands
    ?.map((richBrand) => {
      return {
        [richBrand.name.toLocaleLowerCase().split(' ').join('')]: {
          height:
            richBrand.name.toLocaleLowerCase().split(' ').join('') ===
            'newbalance'
              ? 25
              : 19,
          lineHeight:
            richBrand.name.toLocaleLowerCase().split(' ').join('') ===
            'newbalance'
              ? 45
              : 40,
          align: 'center',
          backgroundColor: {
            image: richBrand.logo,
          },
        },
      };
    })
    .reduce((previousValue, currentValue) => {
      return (previousValue = { ...previousValue, ...currentValue });
    }, {});

  return rich;
};

export const seriesChart = (monthlyTotals: IMonthlyBilling): any => {
  const dataAcessorio: any[] = [];
  const dataAcessorioFaltante: any[] = [];
  const colorAcessorioFaltante: any[] = [];
  const maskValueAcessorioFaltante: any[] = [];
  const maskValueAcessorio: any[] = [];

  const dataCalcado: any[] = [];
  const dataCalcadoFaltante: any[] = [];
  const colorCalcadoFaltante: any[] = [];
  const maskValueCalcadoFaltante: any[] = [];
  const maskValueCalcado: any[] = [];

  const dataConfeccao: any[] = [];
  const dataConfeccaoFaltante: any[] = [];
  const colorConfeccaoFaltante: any[] = [];
  const maskValueConfeccaoFaltante: any[] = [];
  const maskValueConfeccao: any[] = [];

  const normalizeData = () => {
    monthlyTotals.brands.forEach((el) => {
      if (el.segments.length < 3) {
        const acessorio = el.segments.some((el) => el.segment === 'ACESSÓRIO');
        const confec = el.segments.some((el) => el.segment === 'CONFECÇÃO');
        const shoes = el.segments.some((el) => el.segment === 'CALÇADO');

        if (!acessorio) {
          el.segments.splice(0, 0, {
            balance: 0,
            balanceMask: '0',
            positive: false,
            real: 0,
            realMask: '0',
            segment: 'ACESSÓRIO',
          });
        }
        if (!confec) {
          el.segments.splice(2, 0, {
            balance: 0,
            balanceMask: '0',
            positive: false,
            real: 0,
            realMask: '0',
            segment: 'CONFECÇÃO',
          });
        }
        if (!shoes) {
          el.segments.splice(1, 0, {
            balance: 0,
            balanceMask: '0',
            positive: false,
            real: 0,
            realMask: '0',
            segment: 'CALÇADO',
          });
        }
      }
    });
  };

  normalizeData();

  const validateBarLogo = (brand: string): string[] => {
    const segmentLogo = monthlyTotals.brands.find(
      (el) => el.brand === brand
    )?.segments;
    if (segmentLogo?.length === 1) return [segmentLogo[0].segment];
    if (segmentLogo?.length === 2) return [segmentLogo[1].segment];
    if (segmentLogo?.length === 3) return [segmentLogo[1].segment];

    return [];
  };

  const brands: string[] = [];

  monthlyTotals.brands.forEach((el) => {
    brands.push(el.brand);
    el.segments.forEach((element) => {
      if (element.segment === 'ACESSÓRIO') {
        dataAcessorio.push(element.real);
        dataAcessorioFaltante.push(element.balance);
        element.positive === true
          ? colorAcessorioFaltante.push('#219653')
          : colorAcessorioFaltante.push('#E70024');
        maskValueAcessorio.push(element.realMask);
        maskValueAcessorioFaltante.push(element.balanceMask);
      }
      if (element.segment === 'CALÇADO') {
        dataCalcado.push(element.real);
        dataCalcadoFaltante.push(element.balance);
        element.positive === true
          ? colorCalcadoFaltante.push('#219653')
          : colorCalcadoFaltante.push('#E70024');

        maskValueCalcadoFaltante.push(element.balanceMask);
        maskValueCalcado.push(element.realMask);
      }
      if (element.segment === 'CONFECÇÃO') {
        dataConfeccao.push(element.real);
        dataConfeccaoFaltante.push(element.balance);
        element.positive === true
          ? colorConfeccaoFaltante.push('#219653')
          : colorConfeccaoFaltante.push('#E70024');
        maskValueConfeccaoFaltante.push(element.balanceMask);
        maskValueConfeccao.push(element.realMask);
      }
    });
  });

  return {
    dataAcessorio,
    dataAcessorioFaltante,
    colorAcessorioFaltante,
    maskValueAcessorioFaltante,
    maskValueAcessorio,

    dataCalcado,
    dataCalcadoFaltante,
    colorCalcadoFaltante,
    maskValueCalcadoFaltante,
    maskValueCalcado,

    dataConfeccaoFaltante,
    dataConfeccao,
    colorConfeccaoFaltante,
    maskValueConfeccaoFaltante,
    maskValueConfeccao,

    validateBarLogo,
    brands,
  };
};
